module.exports = __webpack_public_path__ + "media/images/gateway/6-c999dc0748d9d714e4144c650e0e8ba2.png";